// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"c5b21765","513":"0957dcd7"}[chunkId] + ".chunk.js";
};